import  { useEffect, useState } from "react";

const VariantSelector = ({ product, setSelectedVariant }) => {
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const variants = product?.product?.attributes;

  // Dynamically match variant based on selectedAttributes
  useEffect(() => {
    if (Array.isArray(variants) && variants.length > 0) {
      const matched = variants.find((variant) =>
        Object.entries(selectedAttributes).every(
          ([key, value]) => variant[key] === value
        )
      );
      if (matched) {
        setSelectedVariant(matched);
      }
    }
  }, [selectedAttributes, setSelectedVariant, variants]);

  if (!Array.isArray(variants) || variants.length === 0) {
    return null; // No variants — nothing to render
  }

  // Get all attribute keys excluding non-attribute fields
  const attributeKeys = Object.keys(variants[0]).filter(
    (key) => key !== "other_attributes" && key !== "_id"
  );

  return (
    <div>
      {attributeKeys.map((attrKey) => {
        const options = [
          ...new Set(variants.map((item) => item[attrKey])),
        ];

        return (
          <div key={attrKey} className="mb-4">
            <h5 className="text-capitalize">Choose {attrKey}</h5>
            <div className="d-flex gap-3 flex-wrap">
              {options.map((option) => (
                <div
                  key={option}
                  onClick={() =>
                    setSelectedAttributes((prev) => ({
                      ...prev,
                      [attrKey]: option,
                    }))
                  }
                  className={`p-2 border rounded text-center cursor-pointer ${
                    selectedAttributes[attrKey] === option
                      ? "border-dark fw-bold text-dark"
                      : "border-secondary text-muted"
                  }`}
                  style={{ minWidth: "80px" }}
                >
                  {option}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VariantSelector;
